import {fitExpandedPanel} from "./lh-78556ebf-geometry.js?v=codex-20261027-r14";
export function mountPosterProof(api) {
  const $ = s => document.querySelector(s);
  const handles = ['flor-citrica', 'beijo-de-coco'];
  const isolatedBeijo = new URLSearchParams(location.search).get('fundo') === 'mascara';
  let selected = isolatedBeijo ? 'beijo-de-coco' : handles[0];
  document.body.classList.add('poster-proof');
  document.body.classList.toggle('beijo-mask-proof', isolatedBeijo);
  // Match the existing static panorama's cover geometry when WebGL is unavailable.
  if (!api.scene3d) {
    const align = () => {
      const stage = $('#spatial-stage'), w = stage.clientWidth, h = stage.clientHeight;
      const scale = Math.max(w/1916, h/821), s = 804*scale/884;
      $('#shop-panel').style.setProperty('--poster-projection', `matrix(${s},0,0,${s},${(w-1916*scale)/2+560*scale},${(h-821*scale)/2+24*scale})`);
      const box=stage.getBoundingClientRect(),left=box.left+(w-1916*scale)/2+560*scale,top=box.top+(h-821*scale)/2+24*scale;
      fitExpandedPanel($('#shop-panel'),{left,top,right:left+804*scale,bottom:top+472*scale},{width:innerWidth,height:innerHeight,top:box.top});
    };
    align(); window.addEventListener('resize', align);
  }
  const poster = document.createElement('section');
  poster.id = 'poster-board'; poster.setAttribute('aria-label', 'As criações da Larrysa');
  poster.innerHTML = `<div class="poster-art"><button type="button" id="poster-photo" aria-label="Ver Flor Cítrica"><img id="poster-image" alt="Flor Cítrica"></button></div>
    <div class="poster-type"><p class="poster-signature">Larrysa's Bakery <span>· Pontinha</span></p><p class="poster-category">Os nossos bolos</p><h2 id="poster-title" class="lh-h1"></h2><p id="poster-description"></p><p id="poster-price"></p><button type="button" id="poster-choose" class="primary"></button><button type="button" id="poster-help" class="text-button">Assistente da Bakery</button></div>
    <nav class="poster-sequence" aria-label="Percorrer os bolos"><button type="button" id="poster-prev" aria-label="Bolo anterior">←</button><span id="poster-position" role="status"></span><button type="button" id="poster-next" aria-label="Bolo seguinte">→</button></nav>`;
  $('#panel-content').prepend(poster);
  // Move existing secondary information into a native disclosure, keeping listeners and state.
  const detail = document.createElement('details'); detail.className = 'poster-details'; detail.hidden = true;
  const summary = document.createElement('summary'); summary.textContent = 'Sobre este produto'; detail.append(summary);
  for (const id of ['cp-recipe-layers','cp-kitchen-note','cp-conservation-note']) { const node = $('#'+id); if (node) detail.append(node); }
  $('.cp-footer-links').before(detail);
  function paint() {
    const p = api.getProduct(selected);
    $('#poster-image').src = p.originalImageResolved;
    $('#poster-image').alt = p.name;
    $('#poster-title').textContent = p.name;
    $('#poster-description').textContent = $('#hero-cake-desc').textContent;
    $('#poster-price').textContent = p.priceLabel;
    $('#poster-photo').setAttribute('aria-label', 'Ver '+p.name);
    $('#poster-choose').textContent = document.body.classList.contains('mobile-panel-expanded') ? 'Escolher '+p.name : 'Aproximar do balcão';
    if (!document.body.classList.contains('entrance-proof')) $('#panel-distance').textContent = document.body.classList.contains('mobile-panel-expanded') ? 'Voltar à loja' : 'Aproximar do balcão';
    $('#poster-position').textContent = `${handles.indexOf(selected)+1} / ${handles.length} · ${p.name}`;
    document.body.dataset.posterShape = p.originalDimensions[0] > p.originalDimensions[1] ? 'landscape' : 'portrait';
  }
  function select(handle) { selected = handle; api.previewFeaturedCakeInHero(handle); paint(); }
  function choose() {
    if (!document.body.classList.contains('mobile-panel-expanded')) api.setPanelExpanded(true);
    else { api.openCounterProductCard(selected); $('#cp-title').tabIndex = -1; $('#cp-title').focus({preventScroll:true}); }
    paint();
  }
  $('#poster-choose').onclick = choose; $('#poster-photo').onclick = choose;
  $('#poster-help').onclick = () => api.openDrawer('ajuda');
  const advance = delta => select(handles[(handles.indexOf(selected)+delta+handles.length)%handles.length]);
  $('#poster-prev').onclick = () => advance(-1); $('#poster-next').onclick = () => advance(1);
  // Also provide the two choices beside the existing product actions.
  const choices = document.createElement('nav'); choices.className = 'poster-product-choices'; choices.setAttribute('aria-label','Escolher outro bolo');
  for (const handle of handles) {
    const b = document.createElement('button'); b.type = 'button'; b.textContent = api.getProduct(handle).name;
    b.onclick = () => { select(handle); api.openCounterProductCard(handle); };
    choices.append(b);
  }
  $('.cp-footer-links').append(choices);
  $('.cp-footer-links [data-panel-view="menu"]').textContent = 'Voltar aos bolos';
  $('[data-close-drawer]').textContent = 'Voltar aos bolos';
  let wasExpanded = false;
  new MutationObserver(() => {
    const expanded = document.body.classList.contains('mobile-panel-expanded');
    if (expanded !== wasExpanded) {
      wasExpanded = expanded;
      if (api.scene3d && !document.body.classList.contains('photographic-room')) {
        api.scene3d.goToGatePose(expanded ? 'near' : 'entrada');
        if (expanded) Object.assign(api.scene3d.targetPose, {y:2.1, pitch:0, fov:54});
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) api.scene3d.setPoseImmediate(api.scene3d.targetPose);
      }
      paint();
    }
  }).observe(document.body, {attributes:true,attributeFilter:['class']});
  $('#panel-distance').addEventListener('click', () => {
    if (document.body.classList.contains('entrance-proof')) return;
    if (!document.body.classList.contains('mobile-panel-expanded')) { api.closeDrawer(); api.setPanelView('welcome'); }
    paint();
  });
  api.setPanelView('welcome'); api.setPanelExpanded(false); select(selected);
  document.body.dataset.posterReady = 'true';
}
